module.exports = Em.ObjectController.extend({
    isVoidOrVoided: Em.computed.or('isVoid', 'isVoided')
})
